import type { PayloadAction } from '@reduxjs/toolkit';
import type { AnalyticsState } from './analytics-interface';

export const setSelectedOrganizationNamesFun = (
  state: AnalyticsState,
  action: PayloadAction<string[]>,
) => {
  state.selectedOrganizationNames = action.payload;
};

export const setAnalyticsDateRangeFun = (
  state: AnalyticsState,
  action: PayloadAction<{ start: string; end: string }>,
) => {
  state.dateRangeStart = action.payload.start;
  state.dateRangeEnd = action.payload.end;
};
